<template>
  <div class="hualu">
    <div class="hualu-img">
      <img src="@/assets/twoStar/4.jpg" alt />
    </div>
    <div class="hualu-box">
      <div v-show="!isShow">
        <div class="hualu-box-title">请填写党员报到相关信息</div>
        <div
          class="hualu-box-template"
          v-for="(data, i) in templateArr"
          :key="i"
        >
          <p>
            <span style="color: red">*</span>
            {{ data.name }}
          </p>
          <input :type="data.type" v-model="data.value" />
        </div>

        <div class="hualu-box-sumbit" @click="sumbit()">
          <button>确认提交</button>
        </div>
      </div>
      <div v-show="isShow" class="isShow">
        <div class="imgbox">
          <img src="@/assets/partyreports/chengg.png" alt="" />
          提交成功
        </div>
        <div>欢迎回家！</div>
        <div>党员管家稍后跟您联系！</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      templateArr: [
        { name: "姓名", type: "text", value: "" },
        {
          name: "身份证号",
          type: "number",
          value: "",
        },
        {
          name: "手机号码",
          type: "text",
          value: "",
        },
        { name: "公司名称", type: "text", value: "" },
        { name: "现党组织关系", type: "text" },
        { name: "现党组织关系所在地", type: "text", value: "" },
        { name: "现党组织关系电话号码", type: "text", value: "" },
      ],
      isShow: false,
    };
  },
  methods: {
    sumbit() {
      let isNext = this.templateArr.some((item, index) => {
        return item.value == "";
      });
      if (isNext) {
        this.$message({
          message: "请填写完整",
          type: "error",
          offset: 300,
        });
        return false;
      }
      if (!/^1[3456789]\d{9}$/.test(this.templateArr[2].value)) {
        this.$message({
          message: "手机号码有误，请重填",
          type: "error",
          offset: 300,
        });
        return false;
      }
      if (
        !/^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
          this.templateArr[1].value
        )
      ) {
        this.$message({
          message: "身份证格式有误，请重新输入",
          type: "error",
          offset: 300,
        });
        return false;
      }
      let regPone = null;
      let mobile = /^((13|14|15|17|18)[0-9]{1}\d{8})$/; // 最新16手机正则
      let tel = /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/; // 座机
      if (this.templateArr[6].value.charAt(0) == "0") {
        // charAt查找第一个字符方法，用来判断输入的是座机还是手机号
        regPone = tel;
      } else if (this.templateArr[6].value.charAt(0) != "0") {
        regPone = mobile;
      }
      if (!regPone.test(this.templateArr[6].value)) {
        this.$message({
          message: "党组织关系号码格式有误，请输入正确的手机号或固定电话号码! 固定电话格式入xxx-yyyyyyyy",
          type: "error",
          offset: 300,
        });
        return false;
      }
      let params = {
        name: this.templateArr[0].value,
        idCard: this.templateArr[1].value,
        phone: this.templateArr[2].value,
        companyName: this.templateArr[3].value,
        partyOrganization: this.templateArr[4].value,
        location: this.templateArr[5].value,
        partyPhone: this.templateArr[6].value,
        typename:'东坡水街商圈综合党委'
      };
      console.log(params)
      this.axios.post("/api/Main/AddInformation", params).then((res) => {
        if (res.data.code == 0) {
          this.isShow = true;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
            offset: 300,
          });
        }
      });
    },
    toindex() {
      this.$router.push("/index");
    },
    back() {
      window.history.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.hualu {
  &-img {
    img {
      width: 100%;
    }
  }
  &-box {
    &-title {
      font-weight: bold;
      line-height: 2;
    }
    &-template {
      input {
        width: 100%;
        border-radius: 0.1rem;
        padding: 0.2rem;
        border: none;
        background: #f4f4f4;
        margin-top: 0.2rem;
        font-size: 0.3rem;
      }
      font-size: 0.26rem;
      margin-top: 0.3rem;
      color: #666666;
    }
    &-sumbit {
      button {
        width: 4.6rem;
        height: 0.76rem;
        background: linear-gradient(
          -70deg,
          rgba(254, 123, 73, 1) 0%,
          rgba(250, 112, 91, 1) 100%
        );
        box-shadow: 0rem 0.06rem 0.12rem 0rem rgba(251, 63, 63, 0.4);
        border-radius: 0.08rem;
        border: none;
        color: #fff;
      }
      text-align: center;
      margin-top: 1rem;
    }
    width: 94%;
    left: 3%;
    padding: 0.4rem;
    background: #fff;
    position: absolute;
    box-shadow: 0rem 0.1rem 0.2rem 0rem rgba(0, 0, 0, 0.1);
    top: 3.4rem;
    border-radius: 0.1rem;
  }
  .isShow {
    .imgbox {
      img {
        width: 2.35rem;
        height: 2.29rem;
      }
      width: 2.35rem;
      font-size: 0.3rem;
      font-weight: 400;
      color: #ff562f;
      text-align: center;
      margin: 0 auto 0.56rem;
    }
    > div:nth-of-type(2) {
      font-size: 0.46rem;
      font-weight: 400;
      color: #666666;
      margin-bottom: 0.2rem;
    }
    > div:nth-of-type(3) {
      font-size: 0.46rem;
      font-weight: 400;
      color: #333333;
    }
    text-align: center;
    padding: 0.84rem 0 3rem;
  }
  padding-top: 1rem;
  font-size: 0.3rem;
}
</style>